import {Component} from '@angular/core';
import {CloudinaryOptions, CloudinaryUploader} from 'ng2-cloudinary';
import {NgForm} from '@angular/forms';
import {Router, ActivatedRoute} from "@angular/router";
import {AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';
import {ToastrService} from 'toastr-ng2';
import {cloudinarUpload} from '../../../../firebase.config';
@Component({
  selector: 'app-add-item',
  templateUrl: './add-item.component.html',
  styleUrls: ['./add-item.component.scss']
})
export class AddItemComponent {

  url: any = '';
  menuItems = {
    title: '',
    description: '',
    offerPercentage: 0,
    extraOptions: [{}],
    offer: false,
    price: [{}],
    category: '',
    thumb: '',
  }
  ItemPrice = [];

  readUrl(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.url = event.target.result;
        //this.imageRef = 1;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
  }


  // addNewChoice = function() {
  //   var newItemNo = this.menuItems.extraOptions.length+1;
  //   this.menuItems.extraOptions.push({});
  // };

  addNewChoice = function () {
    var newItemNo = this.menuItems.extraOptions.length + 1;
    this.menuItems.extraOptions.push({});
  };

  removeChoice = function () {
    if (this.menuItems.extraOptions.length > 0) {
      var lastItem = this.menuItems.extraOptions.length - 1;
      this.menuItems.extraOptions.splice(lastItem);
    }
  }

  addNewPrice = function () {
    var newItemNo = this.menuItems.price.length + 1;
    this.menuItems.price.push({});
  };

  removePrice = function () {
    if (this.menuItems.price.length > 1) {
      var lastItem = this.menuItems.price.length - 1;
      this.menuItems.price.splice(lastItem);
    }
  }
  categories: Array<any>
  categoryData: FirebaseListObservable<any>;
  menuItemsData: FirebaseListObservable<any>;
  imageId: string;

  uploader: CloudinaryUploader = new CloudinaryUploader(
    new CloudinaryOptions(cloudinarUpload)
  );

  constructor(public af: AngularFireDatabase, public toastr: ToastrService, public router: Router) {
    this.menuItemsData = af.list('/menuItems');
    this.categoryData = af.list('/categories');
    this.categoryData.subscribe((response) => {
      this.categories = response
    })
    //Override onSuccessItem to retrieve the imageId
    this.uploader.onAfterAddingFile = (item: any) => {
      item.url = this.uploader.options.url;
      return item;
    };

  }

  onSubmitMainItems(form: NgForm) {
    if (this.menuItems.offerPercentage > 0) {
      this.ItemPrice = this.menuItems.price
      for (let i = 0; i < this.ItemPrice.length; i++) {
        this.ItemPrice[i].specialPrice = (this.ItemPrice[i].value - (this.menuItems.offerPercentage * this.ItemPrice[i].value) / 100);
        console.log("this.ItemPrice" + JSON.stringify(this.ItemPrice));
      }
      this.menuItems.offer = true;
    }
    else {
      console.log("else");
      this.ItemPrice = this.menuItems.price;
      this.menuItems.offerPercentage = 0;
      this.menuItems.offer = false;
    }
    this.uploader.uploadAll();
    this.uploader.onSuccessItem = (item: any, response: string, status: number, headers: any): any => {
      let res: any = JSON.parse(response);
      this.menuItems.thumb = res.url;
      console.log("menuItems" + JSON.stringify(this.menuItems));
      this.menuItemsData.push(this.menuItems).then((res) => {
        this.toastr.success('Menu-Items Data Added Successfully!', 'Success!');
        this.router.navigate(['/menu/manageItems']);
      });
    }
  }

  cancel() {
    this.router.navigate(['/menu/manageItems']);
  }
}



// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/ShunFa/ShunFa-Restaurant Backend/Restaurant_Firebasebackend/webapp/src/app/routes/restaurant/menu-items/add-item/add-item.component.ts